// useThreeModel.ts
import { loadThreeModel } from '@modules/three/utils/loadThreeModel';
import { useQuery } from '@tanstack/react-query';
import * as THREE from 'three';

/**
 * Fetches + parses the 3D model at `url` into a THREE.Object3D,
 * using React Query for caching/loading state.
 */

export function useThreeModel(url?: string) {
  return useQuery<THREE.BufferGeometry, Error>({
    queryKey: ['threeModel', url],
    queryFn: async () => {
      if (!url) throw new Error('Missing model URL');
      return loadThreeModel(url);
    },
    enabled: Boolean(url),
    staleTime: Infinity,
  });
}

export function useThreeModels(urls: string[]) {
  return useQuery<THREE.BufferGeometry[], Error>({
    queryKey: ['threeModels', urls],
    queryFn: async () => {
      if (!urls) throw new Error('Missing model URLs');
      return Promise.all(urls.map((url) => loadThreeModel(url)));
    },
    enabled: Boolean(urls),
    staleTime: Infinity,
  });
}
